import BaseModel from "./BaseModel";

class CommonModel extends BaseModel {
    pathname = "api/v1/common";
    save_prefix = "common_saved_";

    saveValue = (type, object) => {
        localStorage.setItem(`${this.save_prefix}${type}`, JSON.stringify(object));
    };
}

export default CommonModel;
